module.exports = __webpack_public_path__ + "7b4ebd50f5274e5bfca82408ca79c32d.svg";